export default "__VITE_ASSET__BNMrhkCF__"